module.exports = __webpack_public_path__ + "static/media/house-return.30c22cbc.svg";